/**
 * The theatre map's left rail (08 §2.2): one row per ranger in the company - bust, rank
 * insignia, callsign and surname, status chip. Rangers are still chosen after the briefing, but a
 * row OPENS HIS FILE (widgets/serviceFileDialog.ts): asked for in play, because the rail said who
 * was in the company and nothing about what any of them could do or had done.
 */

import './rail.css';
import type { RangerRecord } from '../../../meta/types';
import type { Ctx } from '../context';
import { box, button, el } from '../dom';
import { availability, rankAbbr } from '../text';
import { bust } from '../widgets/dossierCard';
import { rankInsignia } from '../widgets/insignia';
import { openServiceFile } from '../widgets/serviceFileDialog';

function railRow(ctx: Ctx, r: RangerRecord): HTMLElement {
  const state = availability(r);
  // A real button, so the arrow keys walk the rail and Enter opens a file, like everything else.
  const row = button('', () => openServiceFile(ctx, r), state.available ? 'menu-rail-row' : 'menu-rail-row menu-rail-out');
  const call = r.callsign.trim() === '' ? r.firstName : r.callsign;
  // The chip sits under the name: the rail is too narrow for "WOUNDED 1" beside a callsign.
  const names = box(
    'menu-rail-names',
    el('div', 'menu-rail-call', call),
    el('div', 'menu-rail-name menu-small', `${rankAbbr(r.rank)} ${r.surname}`),
    el('span', `menu-chip menu-chip-${state.tone}`, state.chip),
  );
  row.append(bust(r.seed), rankInsignia(r.rank), names);
  row.title = state.available ? `${r.surname}: OPEN HIS FILE` : state.reason;
  return row;
}

/** The company list; `deployable` of `total` is stated so the number never has to be counted. */
export function companyRail(ctx: Ctx, company: readonly RangerRecord[]): HTMLElement {
  const root = el('div', 'menu-rail menu-col');
  const ready = company.filter((r) => availability(r).available).length;
  root.append(el('div', 'menu-rail-count menu-small menu-dim', `${ready} OF ${company.length} CAN DEPLOY`));
  const list = el('div', 'menu-rail-list menu-col menu-scroll menu-grow');
  for (const r of company) list.append(railRow(ctx, r));
  if (company.length === 0) list.append(el('div', 'menu-bad', 'NO RANGERS LEFT'));
  root.append(list);
  return root;
}
